/* eslint-disable no-param-reassign */
import types from '../types';

const initialState = {
  loading: false,
  institutions: [],
  error: '',
};

const institutionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.reducerTypes.INSTITUTION_LIST_PENDING:
      return {
        ...state,
        loading: true,
        institutions: [],
        error: '',
      };
    case types.reducerTypes.INSTITUTION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        institutions: action.payload,
      };
    case types.reducerTypes.INSTITUTION_LIST_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
  }
  return state;
};

export default institutionReducer;
